import React from 'react'
import PropTypes from 'prop-types'
import PathwayDropdown from 'components/PathwayDropdown'
import ContentOverview from 'experienceComponents/ContentOverview'
import HighSchoolPreviewBanner from 'components/HighSchoolPreviewBanner'
import SiteSelector from 'components/SiteSelector'
import {
  HeaderWrapper,
  HeaderBackground,
  HeaderContent,
  StyledHairline,
  StyledTabSet,
  StyledTabButton,
  SiteSelectorWrapper,
  BannerSpacer,
} from './component.styles'

const PathwaysHeader = ({
  activePathway,
  pathways,
  pathwayTitle,
  dataTestId,
  description,
  handleOnPathwayChange,
  isPreview,
  onPathwayChange,
  selectRef,
  title,
  showPreviewBanner = false,
  showSiteSelector = false,
}) => {
  return (
    <HeaderWrapper>
      {isPreview && showPreviewBanner && (
        <>
          <BannerSpacer />
          <HighSchoolPreviewBanner />
        </>
      )}
      <HeaderBackground />
      <HeaderContent isPreview={isPreview}>
        {!isPreview && showSiteSelector && (
          <SiteSelectorWrapper>
            <SiteSelector />
          </SiteSelectorWrapper>
        )}
        <ContentOverview description={description} title={title} />
        <StyledHairline />
        {pathways && pathways.length > 0 && (
          <>
            <div className="pathways_dropdown">
              <PathwayDropdown
                className="pathway_dropdown"
                handleOnChange={handleOnPathwayChange}
                options={pathways.map(pathway => pathway?.title)}
                ref={selectRef}
                value={pathwayTitle}
              />
            </div>
            <StyledTabSet dataTestId={`${dataTestId ?? ''}-tabset`}>
              {pathways.map((pathway, index) => (
                <StyledTabButton
                  dataTestId={`${dataTestId ?? ''}-tab-${(pathway?.title ?? '')
                    .trim()
                    .toLowerCase()}`}
                  isActive={activePathway?.title === pathway?.title}
                  key={index}
                  label={pathway?.title}
                  onClick={() => onPathwayChange?.(pathway)}
                />
              ))}
            </StyledTabSet>
          </>
        )}
      </HeaderContent>
    </HeaderWrapper>
  )
}

PathwaysHeader.propTypes = {
  activePathway: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  dataTestId: PropTypes.string,
  description: PropTypes.string,
  handleOnPathwayChange: PropTypes.func,
  isPreview: PropTypes.bool,
  onPathwayChange: PropTypes.func,
  pathwayTitle: PropTypes.string,
  pathways: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  selectRef: PropTypes.object,
  showPreviewBanner: PropTypes.bool,
  showSiteSelector: PropTypes.bool,
  title: PropTypes.string,
}

export default PathwaysHeader
